import {
  Box,
  Button,
  Grid,
  Paper,
  Typography,
  Link,
  InputLabel,
  Tooltip,
} from "@mui/material";
import loginBG from "../assets/images/login_background.png";
import Logo from "../components/common/Logo";
import Notification from "../components/common/notification/Notification";
import { signupFormFields } from "../components/signup/signupFormFields";
import FormField from "../components/common/FormField";
import React, { FormEvent, useEffect, useState } from "react";
import Validation from "../utils/Validation";
import { InfoOutlined } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import {
  creationClientAction,
  setCreationClientAction,
} from "../store/reducers/adminCreationSlice";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getCheckUniqueCompanyNameAction,
  getCheckUniqueEmailAction,
  getCheckUniqueUserNameAction,
} from "../store/reducers/publicSlice";

interface FormElement {
  id: string;
  lbl?: string;
  placeholder: string;
  type: string;
  isRequired?: boolean;
  autocomplete?: string;
  inputProps?: any;
  tooltipText?: any;
}

const formElements: FormElement[] = [
  {
    id: "companyName",
    lbl: "Company Name",
    placeholder: "Enter Company/Organisation Name",
    type: "text",
    isRequired: true,
    autocomplete: "off",
    // inputProps: {
    //   disabled: true,
    // },
  },
  {
    id: "username",
    lbl: "User Name",
    placeholder: "Create Your User Name",
    type: "text",
    isRequired: true,
    autocomplete: "off",
    tooltipText:
      "A username is a unique alphanumeric 6 characters long word with one capital word, one special character.",
    // inputProps: {
    //   disabled: true,
    // },
  },
  {
    id: "email",
    lbl: "Email",
    placeholder: "Enter Email ID",
    type: "email",
    isRequired: true,
    autocomplete: "off",
    //   inputProps: {
    //     disabled: true,
    //   },
  },

  {
    id: "password",
    lbl: "New Password",
    placeholder: "Enter New Password",
    type: "password",
    isRequired: true,
    autocomplete: "off",
  },
  {
    id: "confirmPassword",
    lbl: "Confirm Password",
    placeholder: "Enter Confirm Password",
    type: "password",
    isRequired: true,
    autocomplete: "off",
  },
];

const Signup: React.FC = () => {
  const [formData, setFormData]: any = useState({});
  const [isActionCalled, setIsActionCalled] = useState(false);

  const { isSignupClientSuccess } = useSelector(
    (state: any) => state.adminCreation
  );

    const {user } = useSelector(
      (state: any) => state.user
    );

  const {
    isUniqueCompanyNameError,
    isUniqueUserNameError,
    isUniqueEmailError,
  } = useSelector((state: any) => state.public);

  useEffect(() => {
    localStorage.removeItem("userEmail");
    localStorage.removeItem("userName");
  }, []);

  
    useEffect(() => {
  
      if (user?.idToken) {
        if (user?.user?.email_verified === "true") {
          if(user?.user?.roles?.includes("TENANT") || user?.user?.roles?.includes("Admin") || user?.user?.roles?.includes("Owner")){
            navigate("/settings");
          }else{
            navigate("/dashboard");
          }
        }
      } 
      else {
        navigate("/signup");
      }
    }, [user]);

  const [isEmailActionCalled, setIsEmailActionCalled] = useState(false);
  const [isUserActionCalled, setIsUserActionCalled] = useState(false);
  const [checkCompanyActionCalled, setIsCheckCompanyActionCalled] =
    useState(false);
  const dispatch = useDispatch();
  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
  ]: any = Validation({
    companyName: formData?.companyName || "",
    username: formData?.username || "",
    email: formData?.email || "",
    password: formData?.password || "",
    confirmPassword: formData?.confirmPassword || "",
  });

  const onChangeAction = (e: any) => {
    const id = e?.target?.id;
    const value = e?.target?.value;
    setFormData({
      ...formData,
      [id]: value,
    });
    resetValidator(e.target.id);
  };

  const onBlurAction = (e: any) => {
    const { id, value } = e.target;
    checkValidator(e.target.id);
    if (id === "email" && value.trim() !== "") {
      setIsEmailActionCalled(true);
    } else if (id === "username" && value.trim() !== "") {
      setIsUserActionCalled(true);
    } else if (id === "companyName" && value.trim() !== "") {
      setIsCheckCompanyActionCalled(true);
    }
  };

  useEffect(() => {
    if (isEmailActionCalled) {
      dispatch(getCheckUniqueEmailAction(formData?.email));
      setIsEmailActionCalled(false);
    } else {
      setIsEmailActionCalled(false);
    }
  }, [isEmailActionCalled]);

  useEffect(() => {
    if (isUserActionCalled) {
      dispatch(getCheckUniqueUserNameAction(formData?.username));
      setIsUserActionCalled(false);
    } else {
      setIsUserActionCalled(false);
    }
  }, [isUserActionCalled]);

  useEffect(() => {
    if (checkCompanyActionCalled) {
      dispatch(getCheckUniqueCompanyNameAction(formData?.companyName));
      setIsCheckCompanyActionCalled(false);
    } else {
      setIsCheckCompanyActionCalled(false);
    }
  }, [checkCompanyActionCalled]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };
  const navigate = useNavigate();

  useEffect(() => {
    if (isActionCalled) {
      if (
        !isError() &&
        error !== null &&
        isActionCalled &&
        !isUniqueCompanyNameError &&
        !isUniqueUserNameError &&
        !isUniqueEmailError
      ) {
        setIsActionCalled(false);
        dispatch(creationClientAction(formData));
      } else {
        setIsActionCalled(false);
      }
    }
  }, [isActionCalled]);

  useEffect(() => {
    console.log("isSignupClientSuccess", isSignupClientSuccess);
    if (isSignupClientSuccess) {
      navigate("/account-verification");
      dispatch(setCreationClientAction(false));
    }
  }, [isSignupClientSuccess]);

  return (
    <>
      <Grid
        container
        component="main"
        sx={{
          height: "100%",
          padding: "80px 0px",
          justifyContent: "center", // Center horizontally
          alignItems: "center", // Center vertically
          position: "relative",
          zIndex: 1, // Ensure content is above the background image
          "&::before": {
            content: '""',
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `url(${loginBG})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: 1, // Set the opacity of the background image
            zIndex: -1, // Place the background image behind the content
          },
        }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          component={Paper}
          // elevation={6}
          square
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center", // Center vertically
            alignItems: "center", // Center horizontally
            width: "100%",
            "max-width": "100%",
            backgroundColor: "rgba(255, 255, 255, 0.50)",
            padding: "16px 0px",
            borderRadius: "25px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: { xs: "0px 16px", sm: "0px" },
              width: "80%",
            }}
          >
            <Logo isTitle={true} isPosition={true} />
            <Typography
              variant="h1"
              fontWeight={600}
              align="center"
              sx={{
                fontSize: { xs: "1.5rem", sm: "2.5rem" },
                color: "#000000",
                padding: "16px 0px",
              }}
            >
              Create Your MMYM Account
            </Typography>
            <Box
              // component="form"
              // noValidate

              sx={{
                mt: 1,
                // display: "ruby",
                // justifyContent: "center", // Center children horizontally
                // flexDirection: "column", // Align children vertically
                // alignItems: "center",
                // width: '70%'
                width: "100%",
              }}
            >
              <Notification />
              {formElements?.map((field, index) => {
                return (
                  <>
                    <InputLabel
                      sx={{
                        color: "#333333",
                        fontWeight: 600,
                        fontSize: "18px",
                        paddingLeft: "16px",
                        marginBottom: "-6px",
                        marginTop: "6px",
                      }}
                      shrink
                      htmlFor={field?.id}
                    >
                      {field?.lbl}
                      {field?.isRequired && (
                        <span style={{ color: "red", fontWeight: 500 }}>*</span>
                      )}
                      {field?.tooltipText && (
                        <Tooltip title={field?.tooltipText || ""}>
                          <InfoOutlined />
                        </Tooltip>
                      )}
                    </InputLabel>
                    <FormField
                      {...{
                        ...field,
                        ...{
                          variant: "outlined",
                          isRounded: true,
                          onChange: onChangeAction,
                          onBlur: onBlurAction,
                          sx: {
                            marginTop: "0px !important",
                            "& input:-webkit-autofill": {
                              WebkitBoxShadow: "0 0 0 1000px #fff inset",
                              WebkitTextFillColor: "#000",
                              background: "transparent",
                              height: "auto !important",
                              marginTop: "0px !important",
                            },
                          },
                          InputProps: {
                            ...(field?.inputProps && field?.inputProps),
                          },

                          error:
                            field?.id === "companyName" &&
                            isUniqueCompanyNameError
                              ? true
                              : field?.id === "username" &&
                                  isUniqueUserNameError
                                ? true
                                : field?.id === "email" && isUniqueEmailError
                                  ? true
                                  : error && error[field?.id],
                          value: formData ? formData[field?.id] : "",
                          helperText:
                            field?.id === "proposedPassword"
                              ? error &&
                                "Use at least 8 characters, one uppercase letter, one lowercase letter, one special character and one number in your password"
                              : error && error[field?.id],
                        },
                      }}
                    />
                  </>
                );
              })}
              <span style={{ display: "flex", justifyContent: "flex-end" }}>
                <Link
                  sx={{
                    display: "flex",
                    justifyContent: "end",
                    textDecoration: "none",
                    fontWeight: 600,
                    marginRight: 2,
                    letterSpacing: 0.5,
                    width: "fit-content",
                  }}
                  href="/"
                >
                  Go To Login
                </Link>
              </span>
              <div style={{ textAlign: "center" }}>
                <Button
                  // type="submit"
                  onClick={(event) => {
                    event.preventDefault(); // Prevent default button behavior
                    handleSubmit(
                      event as unknown as FormEvent<HTMLFormElement>
                    ); // Explicit type casting
                  }}
                  fullWidth
                  variant="contained"
                  sx={{
                    fontWeight: 600,
                    fontSize: "18px",
                    mt: 3,
                    mb: 2,
                    width: "160px", // Adjust the width as needed
                    borderRadius: "20px", // Set a border radius for rounding
                    padding: "10px 16px",
                    textTransform: "none !important",
                    backgroundColor: "#076C6B",
                    letterSpacing: 1.5,
                  }}
                >
                  Sign Up
                </Button>
              </div>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default Signup;
